export class TableDataCellState {
	invalid  = false;
	readOnly = true;
}
